


















































































import {Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import {ScrollButton} from "wings-ui-components";
import UserRolesFilter from "@/components/UserManagement/UserRoles/UserRolesFilter.vue";
import {UserRoleItem} from "@/store/user_management/roles/types";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";

@Component({components:{UserRolesFilter,ScrollButton}})
export default class UserRoles extends BaseItemsPage<UserRoleItem> {
  @Getter("userRoles") userRolesResponse: any;
  private is_show_filter = false;
  currentSort= "name";
  currentSortOrder= "desc";
  tableFields = [
    'name',
    'show_finance_info'
  ];

  getData(): any {
    return this.userRolesResponse;
  }
}
